import Vue from 'vue';
import types from '../mutation-types';
import RequestAPI from '../../api/requests';

export const getters = {
  getRequests($state) {
    return $state.sortOrder.map(requestId => $state.records[requestId]);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getContact: $state => id => {
    const contact = $state.records[id];
    return contact || {};
  },
  getMeta: $state => {
    return $state.meta;
  },
  getAppliedContactFilters: _state => {
    return _state.appliedFilters;
  },
};

export const actions = {
  search: async ({ commit }, { search, page, sortAttr, label, organization }) => {
    commit(types.SET_REQUEST_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload, meta },
      } = await RequestAPI.search(search, page, sortAttr, label, organization);
      commit(types.CLEAR_REQUESTS);
      commit(types.SET_REQUESTS, payload);
      commit(types.SET_REQUEST_META, meta);
      commit(types.SET_REQUEST_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_REQUEST_UI_FLAG, { isFetching: false });
    }
  },

  get: async ({ commit }, { page = 1, sortAttr, label, organization } = {}) => {
    commit(types.SET_REQUEST_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload, meta },
      } = await RequestAPI.get(page, sortAttr, label, organization);
      commit(types.CLEAR_REQUESTS);
      commit(types.SET_REQUESTS, payload);
      commit(types.SET_REQUEST_META, meta);
      commit(types.SET_REQUEST_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_REQUEST_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, { id }) => {
    commit(types.SET_REQUEST_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await RequestAPI.show(id);
      commit(types.SET_REQUEST_ITEM, response.data.payload);
      commit(types.SET_REQUEST_UI_FLAG, {
        isFetchingItem: false,
      });
    } catch (error) {
      commit(types.SET_REQUEST_UI_FLAG, {
        isFetchingItem: false,
      });
    }
  },

  updatePresence: ({ commit }, data) => {
    commit(types.UPDATE_REQUESTS_PRESENCE, data);
  },

  setContact({ commit }, data) {
    commit(types.SET_REQUEST_ITEM, data);
  },
};

const state = {
  meta: {
    count: 0,
    currentPage: 1,
    contact: '',
  },
  records: {},
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isFetchingInboxes: false,
    isUpdating: false,
    isMerging: false,
    isDeleting: false,
  },
  sortOrder: [],
  appliedFilters: [],
};

export const mutations = {
  [types.SET_REQUEST_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.CLEAR_REQUESTS]: $state => {
    Vue.set($state, 'records', {});
    Vue.set($state, 'sortOrder', []);
  },

  [types.SET_REQUEST_META]: ($state, data) => {
    const { count, current_page: currentPage, contact } = data;
    Vue.set($state.meta, 'count', count);
    Vue.set($state.meta, 'currentPage', currentPage);
    Vue.set($state.meta, 'contact', contact);
  },

  [types.SET_REQUESTS]: ($state, data) => {
    const sortOrder = data.map(request => {
      Vue.set($state.records, request.id, {
        ...($state.records[request.id] || {}),
        ...request,
      });
      return request.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_REQUEST_ITEM]: ($state, data) => {
    Vue.set($state.records, data.id, {
      ...($state.records[data.id] || {}),
      ...data,
    });

    if (!$state.sortOrder.includes(data.id)) {
      $state.sortOrder.push(data.id);
    }
  },

  [types.EDIT_REQUEST]: ($state, data) => {
    Vue.set($state.records, data.id, data);
  },

  [types.DELETE_REQUEST]: ($state, id) => {
    const index = $state.sortOrder.findIndex(item => item === id);
    Vue.delete($state.sortOrder, index);
    Vue.delete($state.records, id);
  },

  [types.UPDATE_REQUESTS_PRESENCE]: ($state, data) => {
    Object.values($state.records).forEach(element => {
      const availabilityStatus = data[element.id];
      if (availabilityStatus) {
        Vue.set(
          $state.records[element.id],
          'availability_status',
          availabilityStatus
        );
      } else {
        Vue.delete($state.records[element.id], 'availability_status');
      }
    });
  },

  [types.SET_REQUEST_FILTERS](_state, data) {
    _state.appliedFilters = data;
  },

  [types.CLEAR_REQUEST_FILTERS](_state) {
    _state.appliedFilters = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
